<!--This is the style for what I might imagine the document super search might
    look like (when we get there). Along with the usual page header, it will
    have a sidebar where users can  select a department to search by (not visible
    in mobile, just because it wouldnt be very practical), and a searchbar which
    will also search through all documents on the website.-->

<template>
  <main class="pad">
    <div v-if="!loading">

      <!--Parallax and jumbotron with title-->

      <PageHeader
        title="Document Search"
        logo_url="/media/original_images/seal_3vLPIMx.png"
        image_url="/media/original_images/tahoe2_fjE56TU.jpg"
      >
      </PageHeader>

      <mdb-container>
        <mdb-row>
          <mdb-col>

            <!--Search Bar-->

            <div class="input-group md-form form-sm form-1 pl-0">
              <div class="input-group-prepend">
                <span class="input-group-text lighten-2">
                  <mdbIcon icon="search" />
                </span>
              </div>
              <input
                class="form-control my-0 py-1"
                type="text"
                placeholder="Search"
                v-model="searchQuery"
                aria-label="Search"
              />
            </div>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-3">
          <mdb-col xl=9 lg=12>
            <mdb-row class="my-3">
              <mdb-col>
                <h2><strong>Search Results</strong></h2>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-card-group deck>
                <mdb-card class="m-3" lg=4 md=6>
                  <mdb-card-header class="text-left"><mdb-icon icon="file" class="pr-2"/>Search Result 1</mdb-card-header>
                  <mdb-card-body>
                    <mdb-card-text>Some information about this interesting document.</mdb-card-text>
                    <mdb-btn color="primary" class="btn-sm">Download</mdb-btn>
                  </mdb-card-body>  
                </mdb-card>
                <mdb-card class="m-3" lg=4 md=6>
                  <mdb-card-header class="text-left"><mdb-icon icon="file" class="pr-2"/>Search Result 2</mdb-card-header>
                  <mdb-card-body>
                    <mdb-card-text>Some information about this interesting document.</mdb-card-text>
                    <mdb-btn color="primary" class="btn-sm">Download</mdb-btn>
                  </mdb-card-body>  
                </mdb-card>
                <mdb-card class="m-3" lg=4 md=6>
                  <mdb-card-header class="text-left"><mdb-icon icon="file" class="pr-2"/>Search Result 3</mdb-card-header>
                  <mdb-card-body>
                    <mdb-card-text>Some information about this interesting document.</mdb-card-text>
                    <mdb-btn color="primary" class="btn-sm">Download</mdb-btn>
                  </mdb-card-body>  
                </mdb-card>
              </mdb-card-group>
            </mdb-row>

            <!--Search refine button blocks for ipads only (due to weird formatting issues)-->

            <mdb-row>
          <mdb-col class="mt-5 d-none d-md-block">
            <mdb-card class="mb-3">
              <mdb-card-header color="primary-color">Departments</mdb-card-header>
              <mdb-card-body>
                <mdb-btn-group vertical>
                  <mdb-btn color="primary" class="text-left" active><mdb-icon icon="check" class="mr-2"></mdb-icon>TANF</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Off-Reservation</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Tribal Court</mdb-btn>
                  <mdb-btn color="primary" class="text-left">WUMA</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Cultural</mdb-btn>
                </mdb-btn-group>
              </mdb-card-body>
            </mdb-card>
            </mdb-col>
            <mdb-col class="mt-5 d-none d-md-block">
            <mdb-card>
              <mdb-card-header color="primary-color">Categories</mdb-card-header>
              <mdb-card-body>
                <mdb-btn-group vertical>
                  <mdb-btn color="primary" class="text-left" active><mdb-icon icon="check" class="mr-2"></mdb-icon>Documents</mdb-btn> <!--Have little check show up when selected-->
                  <mdb-btn color="primary" class="text-left">Forms</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Applications</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Notices</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Announcements</mdb-btn>
                </mdb-btn-group>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
            </mdb-row>
          </mdb-col>

          <!--Search Refine button blocks for computers only-->

          <mdb-col xl=3 md=12 class="mt-5 d-none d-xl-block d-block d-sm-none">
            <mdb-card class="mb-3">
              <mdb-card-header color="primary-color">Departments</mdb-card-header>
              <mdb-card-body>
                <mdb-btn-group vertical>
                  <mdb-btn color="primary" class="text-left" active><mdb-icon icon="check" class="mr-2"></mdb-icon>TANF</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Off-Reservation</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Tribal Court</mdb-btn>
                  <mdb-btn color="primary" class="text-left">WUMA</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Cultural</mdb-btn>
                </mdb-btn-group>
              </mdb-card-body>
            </mdb-card>
            <mdb-card>
              <mdb-card-header color="primary-color">Categories</mdb-card-header>
              <mdb-card-body>
                <mdb-btn-group vertical>
                  <mdb-btn color="primary" class="text-left" active><mdb-icon icon="check" class="mr-2"></mdb-icon>Documents</mdb-btn> <!--Have little check show up when selected-->
                  <mdb-btn color="primary" class="text-left">Forms</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Applications</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Notices</mdb-btn>
                  <mdb-btn color="primary" class="text-left">Announcements</mdb-btn>
                </mdb-btn-group>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </div>
  </main>
</template>

<script>
import {
  mdbContainer, 
  mdbRow, 
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardText,
  mdbIcon,
  mdbBtnGroup,
  mdbBtn,
  mdbCardGroup,
} from "mdbvue"
import PageHeader from "@/views/PageHeader.vue";
export default {
  name: "DocumentSuperSearch",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardText,
    mdbIcon,
    mdbBtnGroup,
    mdbBtn,
    mdbCardGroup,
    PageHeader
  }
}
</script>